import React, { useEffect, useState } from 'react';
import useAlert from '../../Alerts/useAlert';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import HTMLReportArea from '../Reporting/HTMLReportArea';

interface HTMLReportProps {
    url: string,
    downloadName: string
}

function HTMLReport({ url, downloadName }: HTMLReportProps) {
    const [loadingReport, setLoadingReport] = useState(true);
    const [report, setReport] = useState<string>();
    const { fetchBlobAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();

    useEffect(() => {
        fetchBlobAuthenticated(url)
            .then(async response => {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error(await response.text());
                }
            })
            .then(text => {
                setLoadingReport(false);
                setReport(text);
            })
            .catch(error => {
                setLoadingReport(false);
                setAlert("danger", "Error", error.message);
            });
    }, [url, setAlert, fetchBlobAuthenticated]);

    return (
        <HTMLReportArea loadingReport={loadingReport} report={report} downloadName={downloadName}></HTMLReportArea>
    );
}

export default HTMLReport;